import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog} from "components/TimelineLogs";


function useLogsOrcamento(id: string | undefined) {
  return useQuery(
    `/v1/orcamento/${id}/logs`,
    async () => {
      const { data } = await axios.get< TimelineLog[]>(
        `/v1/orcamento/${id}/logs`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsOrcamento;
